export default "__VITE_ASSET__sz3oPFHu__"